import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";

function Card({
  qrCodeInfo,
  currentLocale,
  index,
  partOfVideo1,
  resetAnimation,
  timeoutId,
}) {
  const [showMoreInfo, setShowMoreInfo] = useState(false);

  useEffect(() => {
    // remove showMoreInfo class when the card is not showing anymore
    if (partOfVideo1 !== index) {
      setShowMoreInfo(false);
    }
  }, [index, partOfVideo1]);
  return (
    <div
      className={`qrcode-card ${showMoreInfo ? "active" : ""} ${
        partOfVideo1 === index ? "current" : ""
      }`}
    >
      <div className="upper">
        {(index === 0 || index === 2 || index == 3 || index == 5) && (
          <>
            <img className="icon icon1" src="images/icons/cross.svg" alt="" />
            <img className="icon icon2" src="images/icons/tick.svg" alt="" />
          </>
        )}
        {(index === 1 || index === 4 || index == 6 || index == 7) && (
          <>
            <img
              className="icon face icon1"
              src="images/icons/red-face.svg"
              alt=""
            />
            <img
              className="icon face icon2"
              src="images/icons/green-face.svg"
              alt=""
            />
          </>
        )}
        <div className="image-wrapper">
          <img
            className={`image first img${index}`}
            src={`images/cards-usage-${currentLocale}/img1-${index}.png`}
            alt=""
          />
        </div>
        <div className="horizontal-line"></div>
        <div className="image-wrapper">
          <img
            className={`image second img${index}`}
            src={`images/cards-usage-${currentLocale}/img2-${index}.png`}
            alt=""
          />
        </div>
        <p>{qrCodeInfo.texts[currentLocale][index]}</p>
        <button
          onClick={() => {
            setShowMoreInfo(true);
            resetAnimation(partOfVideo1, 1, true);
            clearTimeout(timeoutId.current[1]);
          }}
          className="green-button"
        >
          <img className="left-arrow" src="images/icons/white-arrow-thin.svg" />
          <FormattedMessage id="home.use.button" />
          <img
            className="right-arrow"
            src="images/icons/white-arrow-thin.svg"
          />
        </button>
      </div>
      <div className="lower">
        {(index === 0 || index === 2 || index == 3 || index == 5) && (
          <img className="icon icon2" src="images/icons/tick.svg" alt="" />
        )}
        {(index === 1 || index === 4 || index == 6 || index == 7) && (
          <img
            className="icon face icon2"
            src="images/icons/green-face.svg"
            alt=""
          />
        )}
        <div className="image-wrapper">
          <img
            className={`image second img${index}`}
            src={`images/cards-usage-${currentLocale}/img2-${index}.png`}
            alt=""
          />
        </div>
        <div className="horizontal-line"></div>
        <p className="text">
          {qrCodeInfo.moreInfo[currentLocale][index]}
        </p>
      </div>
    </div>
  );
}

export default Card;
